import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Card, Text, Stack } from '@spaceshipapp/cambridge';
import useYup from '../../../hooks/useYup';
import Description from './Description';
import { getDisplayWeight, getPresetSize } from '../utils';
import { ShipmentType } from '../../../types/common';

interface Props {
  errors?: ReturnType<typeof useYup>['errors'];
}

const Envelope: React.FC<Props> = ({ errors }) => {
  const { t } = useTranslation('common');
  const preset = getPresetSize('envelope', ShipmentType.DOCUMENT);
  const { length, width, height } = preset;

  return (
    <Card>
      <Stack gap="md">
        <div>
          <Text>{t('Parcel.labelDimensions')}</Text>
          <Text>
            {t('Parcel.description', {
              length,
              width,
              height,
              weight: getDisplayWeight(preset, ShipmentType.DOCUMENT),
            })}
          </Text>
        </div>
        <Description errors={errors} />
      </Stack>
    </Card>
  );
};

export default Envelope;
